// Price for additional copies of custom item
var PRINT_SIZE_PRICES = {	
  "8x10\"": 34,    
  "11x14\"": 68,
  "16x20\"": 164,
  "11oz. mug (with 20-25 books from our list)": 19,
  "15oz. mug (with 15-20 books from our list)": 23,
  "iPhone Case (with up to 18 books from our list)": 25, 
  "Samsung Case (with up to 18 books from our list)": 25,
  "252 pieces 10.62 x 13.62\" (max 12 books)": 35,
  "520 pieces 15.74 x 19.74\" (max 12 books)": 48,
  "14.5\"x15.5\" (max 20 books)": 26,               // Tote
  "20x27\" (max 25 books)": 24,  // Tea Towel
  "Softcover layflat (5.25 x 7.25\")": 24,
  "Softcover spiralbound (7x9\")": 24,
  "Hardcover layflat (5.5 x 8.5\")": 34,
};

var FRAME_PRICES = {
  "8x10\"": 130,
  "11x14\"": 180,
  "16x20\"": 250
};

// Maximum number of books that can be selected.
var BOOK_LIMITS = {
  "11oz. mug (with 20-25 books from our list)": 25,
  "15oz. mug (with 15-20 books from our list)": 30,
  "iPhone Case (with up to 18 books from our list)": 18, 
  "Samsung Case (with up to 18 books from our list)": 18, 
  "252 pieces 10.62 x 13.62\" (max 12 books)": 12,
  "520 pieces 15.74 x 19.74\" (max 12 books)": 12,
  "14.5\"x15.5\" (max 20 books)": 20,               // Tote
  "20x27\" (max 25 books)": 25,  // Tea Towel
  "Softcover layflat (5.25 x 7.25\")": 20,
  "Softcover spiralbound (7x9\")": 20,
  "Hardcover layflat (5.5 x 8.5\")": 20,
};

var CUSTOM_BOOK_PRICE = 40;

var IMAGE_EMAIL = "info@idealbookshelf.com";
